import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'tools/browser'

const { Provider, Consumer } = React.createContext({})
const bodyWidth = 270
class Dropdown extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {
      isOpen: false,
      startedOpen: false,
    }

    // refs
    this._timerHandle = null

    // methods
    this._isOpen = this._isOpen.bind(this)
    this._open = this._open.bind(this)
    this._close = this._close.bind(this)
    this._onClick = this._onClick.bind(this)
    this._onSubNavClick = this._onSubNavClick.bind(this)
    this._onMouseOut = this._onMouseOut.bind(this)
    this._onMouseOver = this._onMouseOver.bind(this)
    this._wrapperElem = null
    this._bodyElem = null
  }

  render () {
    const { children, label, openOnClick, ...attributes } = this.props
    const { isOpen } = this.state
    return (
      <React.Fragment>
        {
          openOnClick && this._isOpen() &&
          <ClickAwayListener
            onClick={(e) => { this._close() }}
          />
        }
        <Provider value={ { close: () => this._close() }}>
          <DropdownWrapper
            onMouseOver={openOnClick ? null : (e) => { this._onMouseOver(e) }}
            onMouseOut={openOnClick ? null : (e) => { this._onMouseOut(e) }}
            onClick={openOnClick ? (e) => { this._onClick(e) } : null}
            className={isOpen ? 'shgn-dropdown-wrapper is-expanded' : 'shgn-dropdown-wrapper'}
            innerRef={ref => { this._wrapperElem = ref }}
            {...attributes}
          >
            {label}
            <DropdownBody
              onClick={(e) => this._onSubNavClick(e)}
              className={isOpen ? 'is-expanded' : null}
              innerRef={ref => { this._bodyElem = ref }}
            >
              {children}
            </DropdownBody>
          </DropdownWrapper>
        </Provider>
      </React.Fragment>
    )
  }

  componentDidMount () {
    if (this.props.startOpen === true) {
      this.setState({ startedOpen: true })
      this._open()
    }
  }

  componentDidUpdate () {
    if (this.props.startOpen === true && this.state.startedOpen === false) {
      this.setState({ startedOpen: true })
      this._open()
    }
  }

  _onMouseOut (event) {
    const { onOpen } = this.props
    this._timerHandle = setTimeout(() => {
      this._close()
    }, 50)
    onOpen && onOpen(event)
  }

  _onMouseOver (event) {
    if (this._timerHandle !== null) {
      window.clearTimeout(this._timerHandle)
    }
    this._open(event)
  }

  _isOpen () {
    return this.state.isOpen
  }

  _open (event) {
    const wrapperRect = this._wrapperElem.getBoundingClientRect()
    this._bodyElem.style.top = `${wrapperRect.bottom}px`
    if (wrapperRect.left + bodyWidth > window.innerWidth) {
      this._bodyElem.style.right = '6px'
    } else {
      this._bodyElem.style.left = `${wrapperRect.left}px`
    }
    this.setState({ isOpen: true })
  }

  _close () {
    this.setState({ isOpen: false })
  }

  _onClick (event) {
    const { onOpen } = this.props

    event.preventDefault() // stop going to the url

    // toggle
    if (this._isOpen()) {
      this._close()
    } else {
      this._open()
      onOpen && onOpen()
    }
  }

  _onSubNavClick (event) {
    // stop main nav click
    event.stopPropagation()
  }
}

const DropdownWrapper = styled.div`
    cursor: pointer;
    display: inline-block;
`

const DropdownBody = styled.span`
    visibility: hidden;
    display: none; 
    transition: visibility .25s ease-in-out, opacity .25s ease-in-out;
    position: absolute;
    width: ${bodyWidth}px;
    padding: 0;
    list-style-type: none;
    background: #FFF;
    border: 1px solid #E2E2E2;
    border-radius: 6px;
    box-shadow: 4px 4px 8px 0px rgba(0,0,0,.2);
    opacity: 0;
    font-size: 14px;
    line-height: 21px;
    top: 100%;
    min-height: 40px;
    max-height: 650px;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 151;
    transition: opacity 300ms visibility 300ms;

    &.is-expanded {
        display: block;
        opacity: 1;
        visibility: visible;
    }
`

const ClickAwayListener = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 150;
    background: rgba(0, 0, 0, .05);
`

export const DropdownConsumer = Consumer

Dropdown.defaultProps = {
  openOnClick: true,
}

Dropdown.propTypes = {
  startOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onOpen: PropTypes.func,
  label: PropTypes.node.isRequired,
  openOnClick: PropTypes.bool,
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/atoms/Dropdown/Dropdown.js